import * as React from "react"

function TrashIcon(props)
{
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke="#638CA3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h1.8M21 6h-1.8m0 0-1.95 13.29A2 2 0 0 1 15.273 21H8.728a2 2 0 0 1-1.979-1.71L4.8 6m14.4 0H16M4.8 6H8m0 0V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M8 6h8" />
        </svg>
    );
}

export default TrashIcon;